import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface HeaderProps {
  subtitle?: string
}

export default function Header({ subtitle }: HeaderProps) {
  const location = useLocation()
  const isAll = location.pathname.includes('/all')

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div>
              <h1 className="text-xl font-bold text-gray-900">Font Pairings</h1>
              {subtitle && (
                <p className="text-sm text-gray-500">{subtitle}</p>
              )}
            </div>

            <nav className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
              <Link
                to="/font-pairings"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  !isAll
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Categories
              </Link>
              <Link
                to="/font-pairings/all"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  isAll
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                All Pairings
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}
